import { Trans } from '@lingui/react/macro';

import { AppSettings } from '@/constants';
import { cn } from '@/lib';

import { surfaceVariants } from '../surface/surface-variants';

export interface UrlListItemProps {
  url: string;
  children: React.ReactNode;
  className?: string;
  linkClassName?: string;
}

export function UrlListItem({
  url,
  children,
  className,
  linkClassName,
}: UrlListItemProps) {
  return (
    <li
      className={cn(
        surfaceVariants(),
        'px-2 py-px bg-background/25 inline truncate direction-rtl',
        className,
      )}
    >
      <a
        className={cn(
          'w-4/5 truncate text-[11px] leading-tight font hover:underline relative',
          linkClassName,
        )}
        title={url}
        href={url}
        target='_blank'
        rel='noreferrer'
      >
        {children}
      </a>
    </li>
  );
}

export interface UrlListProps {
  children: React.ReactNode;
  itemsCount?: number;
  totalCount?: number;
}

export function UrlList({
  children,
  itemsCount = 0,
  totalCount = 0,
}: UrlListProps) {
  if (!children) {
    return null;
  }

  return (
    <div>
      <ul className='flex flex-row gap-2 flex-wrap max-h-80 overflow-y-auto overflow-x-hidden'>
        {children}
      </ul>
      {itemsCount && totalCount && itemsCount < totalCount ? (
        <p className='pt-3 font-medium text-xs text-foreground'>
          <Trans>
            Showing preview of {itemsCount} out of total {totalCount} items, to
            see more{' '}
            <a
              href={`${AppSettings.adminAppUrl}`}
              target='_blank'
              rel='noreferrer'
              className='underline'
            >
              visit the admin panel
            </a>
            .
          </Trans>
        </p>
      ) : null}
    </div>
  );
}
